module.exports = "/images/li-ji-yang.jpg?a9663a86617892280a0bff488ff5dfea";